var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCollapseIconForSubStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1601_5417)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27.4492,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(180 27 27.4492)",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6121 9.63835L16.4233 13.4496C16.5008 13.527 16.5564 13.609 16.5901 13.6955C16.6238 13.782 16.6406 13.8743 16.6406 13.9724C16.6406 14.0705 16.6238 14.1628 16.5901 14.2493C16.5564 14.3358 16.5008 14.4178 16.4233 14.4952L12.599 18.3196C12.4541 18.4644 12.2777 18.5369 12.0696 18.5369C11.8615 18.5369 11.685 18.4644 11.5402 18.3196C11.3953 18.1748 11.3251 17.9961 11.3295 17.7836C11.3339 17.5712 11.4085 17.3925 11.5533 17.2477L14.8286 13.9724L11.5402 10.684C11.3953 10.5392 11.3229 10.3649 11.3229 10.1612C11.3229 9.95748 11.3953 9.7832 11.5402 9.63835C11.685 9.49351 11.8637 9.42109 12.0762 9.42109C12.2886 9.42109 12.4673 9.49351 12.6121 9.63835Z",
    fill: "#4A4D53"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.4838,
    y: 26.9331,
    width: 25.9677,
    height: 25.9677,
    rx: 12.9838,
    transform: "rotate(180 26.4838 26.9331)",
    stroke: "white",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_5417"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27.4492,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(180 27 27.4492)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCollapseIconForSubStep);
export default __webpack_public_path__ + "static/media/closeCollapseIconForSubStep.41231159.svg";
export { ForwardRef as ReactComponent };